import React from "react"
import styled from "styled-components"
import text from "../styles/text"
import colors from "../styles/colors"
import media from "styles/media"
import ContentWidth from "./ContentWidth"

const Data = ({ content }) => {
  return (
    <NumberContainer>
      <Stat>{content.stat}</Stat>
      <DataBody dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
    </NumberContainer>
  )
}

const DataCard = ({ content }) => {
  return (
    <ContentWidth>
      <Wrapper>
        <Headline>{content.headline}</Headline>
        <DataContainer>
          {content.columns.map((data, index) => (
            <Data key={index} index={index} content={data} />
          ))}
        </DataContainer>
        {content.source ? (
          <Source dangerouslySetInnerHTML={{ __html: content.source }} />
        ) : null}
      </Wrapper>
    </ContentWidth>
  )
}
const NumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.694vw;

  ${media.fullWidth} {
    gap: 10px;
  }

  ${media.tablet} {
    gap: 0.977vw;
  }

  ${media.mobile} {
    gap: 2.336vw;
  }
`
const Stat = styled.h3`
  font-family: Orbitron, sans-serif;
  color: ${colors.primaryOrange};
  font-size: 2.778vw;

  ${media.fullWidth} {
    font-size: 40px;
  }

  ${media.tablet} {
    font-size: 3.906vw;
  }

  ${media.mobile} {
    font-size: 9.346vw;
  }
`
const DataBody = styled.p`
  ${text.bodyMd};
  color: #636363;
`
const Headline = styled.h4`
  ${text.h4};
  color: ${colors.grey500};
  display: flex;
  align-self: start;
  margin-bottom: 1.111vw;

  ${media.fullWidth} {
    margin-bottom: 16px;
  }

  ${media.tablet} {
    margin-bottom: 1.563vw;
  }

  ${media.mobile} {
    margin-bottom: 3.738vw;
  }
`
const DataContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.389vw;

  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 1.953vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 4.673vw;
  }
`
const Source = styled.p`
  ${text.bodyMd};
  display: flex;
  align-self: start;
  margin-top: 1.389vw;

  ${media.fullWidth} {
    margin-top: 20px;
  }

  ${media.tablet} {
    margin-top: 1.953vw;
  }

  ${media.mobile} {
    margin-top: 4.673vw;
  }
`

const Wrapper = styled.div`
  background-color: ${colors.purple100};
  border-radius: 1.667vw;
  padding: 2.778vw 4.444vw;
  width: 79.444vw;

  ${media.fullWidth} {
    border-radius: 24px;
    padding: 40px 64px;
    width: 1144px;
  }

  ${media.tablet} {
    border-radius: 2.344vw;
    padding: 3.906vw 6.25vw;
    width: 92.188vw;
  }

  ${media.mobile} {
    border-radius: 5.607vw;
    padding: 9.346vw 14.953vw;
  }
`

export default DataCard
